.app-site-search {
  position: relative;
  z-index: 13;
  display: flex;
  justify-content: center;

  button.btn.search-toggle {
    margin-right: 0;
    margin-left: 0;
    padding: 0;
  }

  .search-overlay {
    max-width: 0;
    max-height: 0;
    position: relative;

    .input-container {
      position: relative;

      input {
        width: 100%;
        min-width: 0;
        visibility: hidden;
        @include paddings(5,5,5,25);
        border-bottom: 1px solid $tertiary;
        border-radius: 0;
        @include text-size(18);

        @include placeholder {
          font-style: normal;
          @include text-size(16);
          @include line-height(24);
          font-family: $font-family-primary;

        }
      }

      button[type='submit'].input-group-text {
        visibility: hidden;
        position: absolute;
        top: 50%;
        right: 20px;
        /* Adjust the positioning as needed */
        transform: translateY(-50%);
        background: none;
        border: none;

        svg {
          @include svg-format(14px, 14px, $primary);
          overflow: visible;
        }
      }
    }


    button[type='button'] {
      visibility: hidden;
      padding: 0;
      @include margin-direction(left, 17);
      transform: translateY(1px);

      svg {
        @include svg-format(15px, 15px, $tertiary);
        color: $tertiary;
        stroke: $tertiary;
        stroke-width: 2px;
        overflow: visible;
      }
    }

    &.show {
      max-width: 778px;
      max-height: none;
      @include transition(max-width $transition-med linear);
      display: flex;
      align-items: center;
      justify-content: flex-end;

      button.search-toggle {
        display: none;
      }

      .input-container {

        button[type='submit'] {
          @include transition(visibility $transition-med $transition-med linear);
          visibility: visible;
        }
      }


      button[type='submit'].btn {
        @include line-height(20);
        @include paddings(3,15,3,15);

        &:hover,
        &:focus {
          background-color: $white;
          border-color: $primary;
          color: $primary;
        }
      }

      input {
        @include transition(visibility $transition-med linear, min-width $transition-med linear);
        visibility: visible;
        min-width: 622px;
        border-radius: 22px;
        min-height: 36px;
        max-height: 36px;

        &:focus {
          box-shadow: 0 0 0 0.25rem $primary;
        }
      }

      button[type='button'] {
        @include transition(visibility $transition-med $transition-med linear);
        visibility: visible;

        svg {
          @include svg-format(13px, 13px, #FFF);
          @include margin-direction(bottom, 6);
        }

        &:focus {
          box-shadow: 0 0 0 0.25rem $primary;
        }
      }
    }
  }

  input {
    @include text-size(15);
    @include line-height(20);
    border-radius: 23px;
    min-height: 46px;
    max-width: 435px;
    width: 435px;
    background: #fff;
    outline: none;
    box-shadow: none;
    border: none;
    @include text-size(15);
    @include paddings(13,35,13,20);

    @include placeholder() {
      @include text-size(15);
      @include line-height(20);
      color: #333;
      font-style: italic;
    }
  }

  button[type='submit'].input-group-text {
    background: none;
    border: none;
    outline: none;
    box-shadow: none;
    transition: opacity ease-in 0.25s;

    svg {
      @include svg-format(21.55px, 22.07px, $primary);
      overflow: visible;
    }

    &:hover {
      opacity: 0.8;
      transition: opacity ease-out 0.25s;
    }

    &:focus {
      box-shadow: 0 0 0 0.25rem $primary;
    }
  }

  button[type='button'].search-toggle {
    svg {
      @include svg-format(17.57px, 18px, $primary);
      border-bottom: 1px solid transparent;
      @include padding-direction(bottom, 2);
      @include padding-direction(top, 2);
    }

    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
}


@include media-breakpoint-down(xl) {
  .app-site-search {
    position: relative;


    button.btn.search-toggle {
      display: none;
    }

    .search-overlay {

      &.show {
        max-width: none;
        width: 100%;
        justify-content: center;

        input {
          min-width: 314px;
        }
      }
    }

    .btn.btn-primary {
      display: none;
    }

    .btn.btn-link {
      display: none;
    }

    input.form-control {
      border-radius: 2px;
      @include padding-direction(left, 10);
      height: 36px;
      background: #fff;

      &:focus {
        box-shadow: 0px 0px 8px $primary;
      }
    }

    button[type='submit'].input-group-text {
      position: absolute;
      right: 0;
      top: 0;
      width: 35px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0 4px 4px 0;
      background: $primary;
      outline: none;
      border: none;
      box-shadow: none;

      svg {
        @include svg-format(14px, 14px, #fff);
        transform: translateY(-2px);
      }
    }
  }
}